// dependencies
import { createApp } from 'vue'
import store from '@/directoryDemo/directory-demo-search-store';

// components
import DirectoryDemoQuery from '@/directoryDemo/index/query';
import DirectoryDemoIdeas from '@/directoryDemo/index/ideas';
import VueInitialData from '../libs/vue-initial-data';

const demoQueryApp = createApp(DirectoryDemoQuery);
demoQueryApp.use(store);
demoQueryApp.mount('#directoryDemoQueryApp');

const demoSearchIdeasApp = createApp(DirectoryDemoIdeas);
demoSearchIdeasApp.use(VueInitialData);
demoSearchIdeasApp.mount('#directoryDemoSearchIdeasApp');